// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3UV08","large":"styles_large__3OQFx"};